import { getAuthHeaders } from './auth';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const getPendingVerifications = async () => {
  const response = await fetch(`${API_URL}/api/verifications/pending`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    throw new Error('Failed to get pending verifications');
  }
  
  return response.json();
};

export const confirmVerification = async (shareId, verificationResult) => {
  const response = await fetch(`${API_URL}/api/verifications/confirm`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({
      share_id: shareId,
      verification_result: verificationResult
    })
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Failed to confirm verification');
  }
  
  return response.json();
};

export const rejectVerification = async (shareId) => {
  const response = await fetch(`${API_URL}/api/verifications/${shareId}/reject`, {
    method: 'POST',
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    throw new Error('Failed to reject verification');
  }
  
  return response.json();
};
